<template>
  <div class="row m-0 mb-3 mb-md-1">
    <div class="col-12 p-0 mb-2">
      <div class="row m-0 align-items-center" v-if="showMore">
        <store-product v-for="product in filteredProducts.slice(0, 8)" :key="product.id" :item="product" :storeLink="storeLink"></store-product>
      </div>
      <div class="row m-0 align-items-center" v-else>
        <store-product v-for="product in filteredProducts.slice(0, 4)" :key="product.id" :item="product" :storeLink="storeLink"></store-product>
      </div>
    </div>
    <div class="col-12 p-0" v-if="filteredProducts.length > 4">
      <div class="row m-0 align-items-center justify-content-center">
        <div class="col-auto p-0">
          <button class="btn btn-outline w-100" @click="showMore = !showMore" v-if="showMore">
            Show less
            <span class="small">
              <ios-arrow-up-icon />
            </span>
          </button>
          <button class="btn btn-outline w-100" @click="showMore = !showMore" v-else>
            Show more
            <span class="small">
              <ios-arrow-down-icon />
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['products', 'storeLink'],
  components: {
    'store-product': () => import('@/components/landing/StoreProduct.vue')
  },
  data () {
    return {
      showMore: false
    }
  },
  computed: {
    filteredProducts () {
      // const search = this.search.toLowerCase().trim()
      return this.products.filter((product) => !product.disabled).sort((a, b) => {
        if (a.featured && b.featured | (!a.featured && !b.featured)) {
          return a - b
        } else if (a.featured && !b.featured) {
          return -1
        } else {
          return 1
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
